import { useEffect, useState } from 'react';
import { call } from '../api';

/**
 * Regel bovenaan een detailpagina (zoals Ether): "92% match · omdat je van Thriller houdt · Eindigt om 22:45".
 * Match komt uit je smaakprofiel (pas na genoeg kijkgeschiedenis); de eindtijd houdt rekening met waar je was.
 */

const cache = new Map<string, Promise<{ match: number | null; because: string | null }>>();

function matchFor(genres: string[]) {
  const k = genres.slice().sort().join(',');
  let p = cache.get(k);
  if (!p) {
    p = call<{ match: number | null; because: string | null }>(`/api/taste/match?genres=${encodeURIComponent(k)}`).catch(() => ({ match: null, because: null }));
    cache.set(k, p);
  }
  return p;
}

export function DecisionLine({ genres, remainingSec }: { genres: string[]; remainingSec?: number | null }) {
  const [m, setM] = useState<{ match: number | null; because: string | null } | null>(null);
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (!genres.length) return;
    void matchFor(genres).then(setM);
  }, [genres.join(',')]);
  // Eindtijd bijwerken terwijl de pagina open staat
  useEffect(() => {
    const t = window.setInterval(() => setNow(Date.now()), 60_000);
    return () => window.clearInterval(t);
  }, []);
  const ends = remainingSec && remainingSec > 60 ? new Date(now + remainingSec * 1000).toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' }) : null;
  if (!m?.match && !ends) return null;
  return (
    <div className="decision-line">
      {m?.match ? <strong className="decision-match">{m.match}% match</strong> : null}
      {m?.match && m.because ? <span>omdat je van {m.because.toLowerCase()} houdt</span> : null}
      {ends && <span>Eindigt om {ends}</span>}
    </div>
  );
}
